import { faHome, faInfo, faExpand } from '@fortawesome/free-solid-svg-icons';

export const tools = <const>[
  { id: 0, title: 'Naar begin', icon: faHome },
  { id: 1, title: 'Toon uitleg', icon: faInfo },
  { id: 2, title: 'Fullscreen', icon: faExpand },
];

export type ToolsName = typeof tools[number]['title']